import { ScrollProviderContext } from "./ScrollProviderContext";
import { useEffect, useState } from "react";

function ScrollProvider(props) {
    const {
        children,
    } = props;

    const [scrollPosition, setScrollPosition] = useState(0);

    const handleScroll = () => {
        const position = document.body.scrollTop;
        setScrollPosition(position);
    };

    useEffect(() => {
        document.body.addEventListener('scroll', handleScroll, {passive: true});

        return () => {
            document.body.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return <ScrollProviderContext.Provider value={{
        scrollPosition
    }}>
        {children}
    </ScrollProviderContext.Provider>
}

export default ScrollProvider;
